/**
 *
 * Asynchronously loads the component for AccessibilityStatementPage
 *
 */

import loadable from 'utils/loadable';

// @
export default loadable(() => import('./index'));
